import { loadScript } from "vue-plugin-load-script";

export default {
  computed: {
    isOnCall() {
      return this.$store.getters["callState/isOnCall"];
    },

    currentCallGlobalId() {
      return this.isOnCall
        ? this.$store.getters["callState/currentCall"].globalId
        : null;
    },

    currentCallPhoneNumber() {
      return this.isOnCall
        ? this.$store.getters["callState/currentCall"].phoneNumber
        : null;
    },
  },

  methods: {
    loadIvrScript() {
      this.$store.dispatch("callState/updateIvrActive", true);
      loadScript(
        "https://aligev55.zw-callitonce.alestra.net.mx/agentdesktop/libs/servicepattern-sdk-v1.js"
      )
        .then(() => {
          window.bpspat.api.init(
            "https://aligev55.zw-callitonce.alestra.net.mx"
          );
        })
        .catch(() => {
          console.error(
            "Fallo al carga el sdk, Refresque la pagina para realizar la llamada"
          );
        });
      setTimeout(() => {
        this.checkStatus();
        this.intervalo = window.setInterval(() => {
          this.checkStatus();
        }, 5000);
      }, 2000);
    },

    checkStatus() {
      window.bpspat.api.getState(this.statusChecked);
    },

    statusChecked(state) {
      this.$store.dispatch("callState/updateIvrLoaded", true);
      console.log({ state });
      switch (state.data.status) {
        case "busy":
          {
            if (!this.$store.getters["callState/currentCall"]) {
              this.$store.dispatch("callState/updateCurrentCall", {
                phoneNumber: state.data.interactions[0].phone_number,
                globalId: state.data.interactions[0].global_id,
              });
            } else if (
              this.$store.getters["callState/currentCall"].globalId !==
              state.data.interactions[0].global_id
            ) {
              this.$store.dispatch("callState/resetState");
              this.$store.dispatch("callState/updateCurrentCall", {
                phoneNumber: state.data.interactions[0].phone_number,
                globalId: state.data.interactions[0].global_id,
              });
            }
          }
          break;
        default: {
          this.$store.dispatch("callState/updateCurrentCall", null);
        }
      }
    },
  },
};
